export default {
    title: 'Beschaffungen',
    order_number: 'BA.-Nummer',
    id: 'A.-Nr.',
    type: 'Art',
    price: 'Betrag',
    price_net: 'Betrag (netto)',
    user_id: 'Mitarbeiter',
    category_id: 'Kategorie',
    cost_center_id: 'Kostenstelle',
    cost_center: 'Kostenstelle',
    created_at: 'Datum',
    status: 'Status',
    date: 'Datum',
    year: 'Jahr',
    user_name: 'Mitarbeiter (Name)',
    user_email: 'Mitarbeiter (E-Mail)',
    reason: 'Grund der Angebotswahl',
    category: 'Kategorie',
    open: 'Entwurf',
    positions: 'Bestellung',
    supplier: 'Lieferant',
    qf_toApprove: 'Zu Genehmigen',
    qf_myOrders: 'Meine Beschaffungen',
    qf_closed: 'Abgeschlossen'
}